<div class="leagues-page-container">
  <app-leagues class="z-index--1"></app-leagues>
</div>
